import React from 'react';
import { statInfo } from '../../data/guide/statGuide';
import { PriorityBadge } from './PriorityBadge';
import type { BuildStyle } from '../../types/classBuild';

/** Prioridades del estilo elegido. Filas apiladas: legibles en celular sin desplazamiento horizontal. */
export function StatPriorityTable({
  style
}: {
  style: BuildStyle;
}) {
  const rows = statInfo.filter(s => style.stats[s.key]);
  return <table className="w-full border-collapse text-left" data-id="element-432" data-mp="3g0qioy7sq2t4">
      <caption className="sr-only" data-id="element-433" data-mp="3fy4cb1wn5tch">Prioridad de estadísticas para {style.name}</caption>
      <thead className="sr-only" data-id="element-434" data-mp="3kwxgu4tyaa0i">
        <tr data-id="element-435" data-mp="3pq0989mzrdf4">
          <th scope="col" data-id="element-436" data-mp="3ppi931x7kf1x">Estadística</th>
          <th scope="col" data-id="element-437" data-mp="3pqjt3vw7cbvs">Prioridad</th>
          <th scope="col" data-id="element-438" data-mp="3tr3p2w51h9gc">Detalle</th>
        </tr>
      </thead>
      <tbody className="divide-y divide-white/10" data-id="element-439" data-mp="3ttg6n86vxhsv">
        {rows.map(s => {
        const cell = style.stats[s.key]!;
        return <tr key={s.key} className="grid grid-cols-[6.5rem_1fr] items-center gap-x-3 gap-y-1 py-3 sm:grid-cols-[8rem_11rem_1fr]" data-id="element-440" data-mp="7jlx8g8a9djd">
              <th scope="row" className="font-semibold text-white" data-id="element-441" data-mp="2a0fh1b840jui">
                {s.name} <span className="text-xs font-normal text-gray-500" data-id="element-442" data-mp="24yq2hlloho1o">{s.short}</span>
              </th>
              <td data-id="element-443" data-mp="20z7gsnm198xs">
                <PriorityBadge p={cell.p} data-id="element-444" data-mp="20ypnnzuo3au3" />
              </td>
              <td className="col-span-2 text-sm text-gray-400 sm:col-span-1" data-id="element-445" data-mp="1vzmmwrlpzqrx">{cell.note ?? ''}</td>
            </tr>;
      })}
      </tbody>
    </table>;
}